/* eslint-disable import/no-unassigned-import */
import { FrameworkConfiguration, PLATFORM } from 'aurelia-framework';
export { CustomerService } from './services/customer-service';
export { enumToDictionary } from './services/enum-to-dictionary';
export { enumToExtendedArray } from './services/enum-to-extended-array';
export { dashboardLayoutBreakpoints } from './services/dashboard-layout-breakpoints';
export { predefinedDateIntervals } from './services/get-predefined-date-intervals';
export { IDateInterval } from './interfaces/i-date-interval';
export { AccountTypeValueConverter } from './converters/account-type-converter';
export { InstrumentTypeValueConverter } from './converters/instrument-type-converter';
export { NumeralConverter } from './services/numeral-converter';
export { ReportPageDataToWidgetsValueConverter } from './converters/report-page-data-to-widgets-converter';
export { WidgetService, getWidgetPropertiesMetadata } from './services/widget-service';
export { IWidget } from './widgets/i-widget'
export { widget } from './widgets/widget-decorator';
export { DateValueConverter } from './converters/date-converter';
export { NumericFormatterValueConverter } from './converters/numeric-formatter';
export { WidgetBase } from './widgets/widget-base';
export { ChartWidgetBase } from './widgets/chart-widget-base';
export { IApplicationFilter } from './interfaces/i-application-filter';
import './extensions/array-extensions';
export { when } from './extensions/array-extensions';
export { ForbiddenException } from './exceptions/forbidden-exception';
export { BadServiceRequestException } from './exceptions/bad-service-request-exception';
export { NotFoundException } from './exceptions/not-found-exception';
import './extensions/response-extensions';
export { usingTraceAwareProgress } from './decorators/using-progress';
export { CacheService } from './services/cache-service';
export { InstrumentTypesCache } from './services/instrument-types-cache';
import './extensions/promise';
export { getChartReadyPromise } from './services/chart-ready';
export { TextWidget } from './widgets/text-widget/text-widget';
export { PortfolioReportCache } from './services/portfolio-report-cache';
export { WidgetPropertyType } from './widgets/widget-property-type';
export { PROPERTIES_METADATA_KEY, property } from './widgets/property-decorator';
export { IPropertyMetadata } from './widgets/i-property-metadata';
export { IWidgetMetadata } from './widgets/i-widget-metadata';
export { CombinedQueryInstrumentsResponseItem } from './types/combined-query-instruments-response-item';
export { chartThemes } from './services/chart-themes';
export { IExcelExportData } from './interfaces/i-excel-export-data';
export { loadApiConfig, getServiceUrl, getNatsUrl, apiConfig } from './services/api-config';
export {ApiService} from './services/api-service';

export function configure(frameworkConfiguration: FrameworkConfiguration) {
  frameworkConfiguration.globalResources([
    PLATFORM.moduleName('@dynamik/common/behaviours/stop-propagation'),
    PLATFORM.moduleName('@dynamik/common/converters/account-type-converter'),
    PLATFORM.moduleName('@dynamik/common/converters/action-type-converter'),
    PLATFORM.moduleName('@dynamik/common/converters/date-converter'),
    PLATFORM.moduleName('@dynamik/common/converters/numeric-formatter'),
    PLATFORM.moduleName('@dynamik/common/converters/report-page-data-to-widgets-converter'),
    PLATFORM.moduleName('@dynamik/common/converters/instrument-type-converter'),
    PLATFORM.moduleName('@dynamik/common/converters/widget-color-converter'),
    PLATFORM.moduleName('@dynamik/common/converters/widget-template-color-converter'),
    PLATFORM.moduleName('@dynamik/common/elements/font-selector/font-selector'),
    PLATFORM.moduleName('@dynamik/common/elements/message/message'),
    PLATFORM.moduleName('@dynamik/common/widgets/image-widget/image-widget'),
    PLATFORM.moduleName('@dynamik/common/widgets/dimension-over-time-widget/dimension-over-time-widget'),
    PLATFORM.moduleName('@dynamik/common/widgets/current-date-widget/current-date-widget'),
    PLATFORM.moduleName('@dynamik/common/widgets/customer-name-widget/customer-name-widget'),
    PLATFORM.moduleName('@dynamik/common/widgets/instrument-info-widget/instrument-info-widget'),
    PLATFORM.moduleName('@dynamik/common/widgets/instrument-type-info-widget/instrument-type-info-widget'),
    PLATFORM.moduleName('@dynamik/common/widgets/mandat-widget/mandat-widget'),
    PLATFORM.moduleName('@dynamik/common/widgets/nav-breakdown-widget/nav-breakdown-widget'),
    PLATFORM.moduleName('@dynamik/common/widgets/nav-widget/nav-widget'),
    PLATFORM.moduleName('@dynamik/common/widgets/portfolio-value-widget/portfolio-value-widget'),
    PLATFORM.moduleName('@dynamik/common/widgets/report-date-widget/report-date-widget'),
    PLATFORM.moduleName('@dynamik/common/widgets/text-widget/text-widget'),
  ]);
}
